import { createFileRoute } from '@tanstack/react-router';
import { JobPostImportRequestsShowTemplate } from '@/features/agent/provided_job_posts/new/csv/templates/JobPostImportRequestsShowTemplate';

export const Route = createFileRoute('/agent/provided_job_posts/new/csv/$jobPostImportRequestId/')({
  staticData: { title: 'CSVから取り込み' },
  component: JobPostImportRequestsShow,
});

function JobPostImportRequestsShow() {
  const { jobPostImportRequestId } = Route.useParams();

  return <JobPostImportRequestsShowTemplate encryptId={jobPostImportRequestId} />;
}
